module.exports = __webpack_public_path__ + "img/3x.b1b488e.jpg";